export const IMAGE_TYPE = "image"
export const AUDIO_TYPE = "audio"